<div class="form-situations">
  <header
    *ngIf="!hideDates"
    class="mb-2 form-situations__header"
    [ngClass]="{ 'form-situations__disabled': form.disabled }"
  >
    <span class="mr-3 mb-2" *ngIf="startDate">
      <strong>Data inicial:</strong>
      <span class="text-nowrap">
        {{ startDate | date: dateFormat : '+00:00' }}
      </span>
    </span>
    <span class="mr-3 mb-2" *ngIf="endDate">
      <strong>Data de retorno:</strong>
      <span class="text-nowrap">
        {{ endDate | date: dateFormat : '+00:00' }}
      </span>
    </span>
    <span class="mb-2" *ngIf="type === eTimeType.hour">
      <strong>Duração:</strong>
      <span class="text-nowrap">
        {{ startDate | differenceInTime: endDate }}
      </span>
    </span>
  </header>
  <form class="small-form-field form-situations" [formGroup]="form">
    <div *ngIf="$any(situationsArray.controls) as situationsArrayControls">
      <div
        class="row"
        formArrayName="situations"
        *ngFor="let situationControl of situationsArrayControls; let i = index"
      >
        <app-form-field class="col-12 col-sm-6" appearance="outline">
          <app-label>Situação</app-label>
          <app-select
            [formControl]="situationControl.controls.situation"
            [compareWith]="compareSituations"
            [required]="required || !!situationControl.controls.duration.value"
          >
            <app-option value="loader" *ngIf="loader$ | async">
              <app-progress-spinner
                class="mx-auto"
                color="primary"
                [diameter]="24"
              ></app-progress-spinner>
            </app-option>
            <app-option *ngIf="!dataSource?.length">Nenhuma</app-option>
            <app-option
              class="multiline-option"
              *ngFor="let situation of dataSource"
              [value]="situation"
              [disabled]="
                situation?.granted_days_required && type === eTimeType.hour
              "
            >
              {{ situation?.name || situation?.code }}
            </app-option>
          </app-select>
        </app-form-field>
        <div
          [ngClass]="{
            'col-12 col-sm-6':
              i === 0 &&
              (type === eTimeType.hour ||
                (type === eTimeType.day &&
                  !situationControl.controls.situation.value
                    ?.granted_days_required)),
            'col-10 col-sm-4 col-lg-5':
              i > 0 &&
              (type === eTimeType.hour ||
                (type === eTimeType.day &&
                  !situationControl.controls.situation.value
                    ?.granted_days_required)),
            'col-6 col-sm-3':
              i === 0 &&
              type === eTimeType.day &&
              situationControl.controls.situation.value?.granted_days_required,
            'col-6 col-sm-2 col-lg-3':
              i > 0 &&
              type === eTimeType.day &&
              situationControl.controls.situation.value?.granted_days_required,
            'form-situations__disabled':
              (i > 0 || situationsArrayControls.length === 1) && !form.disabled,
          }"
        >
          <app-form-field
            class="w-100"
            appearance="outline"
            *ngIf="type === eTimeType.day; else timePicker"
          >
            <app-label>Qtd de dias</app-label>
            <app-input
              type="number"
              min="1"
              autocomplete="off"
              name="new-num_days"
              [max]="maxDays"
              [readonly]="i > 0"
              [formControl]="situationControl.controls.duration"
            ></app-input>
          </app-form-field>
          <ng-template #timePicker>
            <app-form-field class="w-100" appearance="outline">
              <app-label>Duração (horas:minutos)</app-label>
              <app-input
                type="time"
                step="60"
                autocomplete="off"
                name="new-time-picker"
                [max]="maxTime"
                [readonly]="situationsArray.controls.length === 1"
                [formControl]="situationControl.controls.duration"
              ></app-input>
            </app-form-field>
          </ng-template>
        </div>
        <app-form-field
          class="col-{{ i === 0 ? '6' : '4' }} col-sm-{{ i === 0 ? '3' : '2' }}"
          appearance="outline"
          appTooltip="Quantos dias devem ser pagos pela empresa, no caso de um afastamento pelo INSS, por ex."
          *ngIf="
            type === eTimeType.day &&
            situationControl.controls.situation.value?.granted_days_required
          "
        >
          <app-label>Dias justificados</app-label>
          <app-input
            type="number"
            min="0"
            autocomplete="off"
            name="new-num_days"
            [max]="situationControl.controls.duration?.value"
            [formControl]="situationControl.controls.granted_days"
          ></app-input>
        </app-form-field>
        <div class="col-2 col-sm-1 d-flex align-items-center" *ngIf="i > 0">
          <app-button
            variant="ghost-destructive"
            size="circle"
            (click)="situationsArray.removeAt(i)"
          >
            <app-icon>close</app-icon>
          </app-button>
        </div>
      </div>
      <div class="w-100 d-flex align-items-start">
        <app-button
          variant="ghost-primary"
          *ngIf="multiples && situationsArrayControls.length < 2 && addReleased"
          [disabled]="form.disabled"
          (click)="addSituation()"
        >
          Adicionar situação
        </app-button>
      </div>
    </div>
  </form>
</div>
